/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：281
 */

module.exports = {
  shareToOthers: "style_shareToOthers__u6OY7",
  qrWrapper: "style_qrWrapper__1uWkX",
  blocking: "style_blocking__20p6a",
  iconWrapper: "style_iconWrapper__2QI8W",
  refreshIcon: "style_refreshIcon__3DOiP",
  qrCode: "style_qrCode__koEcW",
  message: "style_message__1tpK9",
  shareLinkWrapper: "style_shareLinkWrapper__1rQdk",
  link: "style_link__3VnNA",
  copyBtn: "style_copyBtn__Iz1FI",
  copied: "style_copied__2YBn7",
  disabled: "style_disabled__2vrmy",
  lineWrapper: "style_lineWrapper__EEuWk",
  line: "style_line__3V5sK",
  settings: "style_settings__2x088",
  settingsIcon: "style_settingsIcon__3irFE",
  rotateSettingsIcon: "style_rotateSettingsIcon__k8ugD",
  settingWrapper: "style_settingWrapper__AJO6Y",
  title: "style_title__10J6n",
  workInfo: "style_workInfo__7CeCV",
  changePoster: "style_changePoster__3ZM2-",
  required: "style_required__niH7M",
  invisible: "style_invisible__2QnJV"
}
